module.exports = __webpack_public_path__ + "static/media/my school.ed111dbb.png";